import React from 'react';
import { Paper, Typography, Box, Stack } from '@mui/material';

export function StatsCard({ title, value, description, icon }) {
    return (
        <Paper
            variant="outlined"
            sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: 'background.paper',
                borderColor: 'divider',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%'
            }}
        >
            {/* Header : Title & Icon */}
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography
                    variant="caption"
                    sx={{
                        fontWeight: 700,
                        textTransform: 'uppercase',
                        color: 'text.secondary',
                        letterSpacing: '0.05em',
                    }}
                >
                    {title}
                </Typography>

                <Box
                    sx={{
                        color: 'primary.main', // ta couleur gold peut être définie dans le thème
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    {icon}
                </Box>
            </Stack>

            {/* Value */}
            <Box sx={{ mt: 2, mb: 0.5 }}>
                <Typography
                    variant="h5"
                    component="div"
                    sx={{
                        fontWeight: 700,
                        color: 'text.primary',
                    }}
                >
                    {value}
                </Typography>
            </Box>

            {/* Description */}
            <Typography
                variant="caption"
                sx={{
                    color: 'text.secondary',
                    fontWeight: 500,
                }}
            >
                {description}
            </Typography>
        </Paper>
    );
}
